<template>
<section class="fancy">
	<div class="container">
		<div class="fancy-box">
			<div class="headline-lg">Asset packs</div>
			<p>Through our Kickstarter campaign you have helped us to unlock several KS exclusive asset packs. Those asset packs will remain exclusive to our KS backers for at least one year after launch. Don't worry - they will find their way into the asset
				store eventually.</p>
			<div class="box-wrapper">

				<template v-for="(item, name, index) in settings">
					<div v-bind:class="hasAssets(item.pack)" v-on:click="showModal(name)" :key="index">
						<div class="box-inner">
							<div class="image shadow">
								<img :src="require(`@/assets/img/${item.image}`)" :alt="'Image Asset ' + item.name">
							</div>
							<div class="title">
								{{ item.name }}
							</div>
							<div v-if="hasDownload(item.pack, item.download)" class="download">
								<img :src="require(`@/assets/svg/ic_downloads.svg`)" :alt="Dwarven">
							</div>
						</div>

						<b-modal :id="name" hide-footer :title="item.name" placement="bottom" triggers="hover click focus">
							<div class="row image-wrapper">
								<img :src="require(`@/assets/img/${item.image}`)" :alt="'Image Asset ' + item.name">
							</div>							
							<div v-html="item.text"></div>
							<div v-if="hasDownload(item.pack, item.download)" class="container-banner">
								<p class="container-download">
									<a :href="item.download" class="button">Download Pack</a>
									<a href="https://www.caeora.com/" target="_blank">
										<img :src="require(`@/assets/img/caeora.png`)" alt="Download">
									</a>
								</p>
							</div>
						</b-modal>
					</div> 
				</template>

			</div>			
			<div class="legend">
				<div><span class="legend-text">Not included in your order</span> <span class="img-wrapper"><img src="~@/assets/img/img_legende_locked.png" alt="Image Icon Locked"></span></div>
				<div><span class="legend-text">You have unlocked this asset pack</span> <span class="img-wrapper"><img src="~@/assets/img/img_legende_unlocked.png" alt="Image Icon Unocked"></span></div>
			</div>
		</div>
	</div>

	


</section>
</template>


<script>
export default {
	name: 'SectionFancyAsset',
	props: {
		user: Object,
	},
	methods: {
		hasAssets: function (val) {

			if(val == 'pack-giant-creatures') {
				return 'box scale unlocked';
			}

			if( this.user.token.groups.includes('/Lifetime 2017') ) {
				if( this.user.token.realm_access.roles.includes(val) || this.user.token.assets.includes(val) ) {
					return 'box scale unlocked';
				}
				if( val == "social-goals" && this.user.token.assets.includes(val) ) {
					return 'box scale unlocked';
				}
			}

			if( this.user.token.groups.includes('/Basic') || this.user.token.groups.includes('/Preorder') || this.user.token.groups.includes('/Preorder Sub') ) {
				return 'box scale locked';
			}

			if(typeof this.user.token.assets !== 'undefined') {
				if( this.user.token.realm_access.roles.includes(val) || this.user.token.assets.includes(val) ) {
					return 'box scale unlocked';
				}
				if( val == "social-goals" && this.user.token.assets.includes(val) ) {
					return 'box scale unlocked';
				}
			}

			return 'box scale locked';
		},
		hasDownload: function (val, download) {

			if( download != null ) {
				if(val == 'pack-giant-creatures') {
					return true;
				}

				if( this.user.token.groups.includes('/Lifetime 2017') ) {
					if( this.user.token.realm_access.roles.includes(val) || this.user.token.assets.includes(val) ) {
						return true;
					}
					if( val == "social-goals" && this.user.token.assets.includes(val) ) {
						return true;
					}
				}

				if( this.user.token.groups.includes('/Basic') || this.user.token.groups.includes('/Preorder') || this.user.token.groups.includes('/Preorder Sub') ) {
					return false;
				}

				if(typeof this.user.token.assets !== 'undefined') {
					if( this.user.token.realm_access.roles.includes(val) || this.user.token.assets.includes(val) ) {
						return true;
					}
					if( val == "social-goals" && this.user.token.assets.includes(val) ) {
						return true;
					}
				}
			}

			return false;
		},

		showModal(id) {
			this.$bvModal.show(id)
		},
	},
	data: () => ({
		settings: packs
	}),
}


let packs = {
	dwarves: {
		name: "Dwarven",
		image: "img_assetpack_dwarven.jpg",
		pack: "pack-dwarves",
		text: `<p><strong>25 Kickstarter exclusive</strong> assets for regional landmarks, city buildings and world maps.</p>`,
		download: "https://deios-api.prd.dungeonfog.com/download?file=Caeora_Dwarven_Pack.zip",
	},
	elves: {
		name: "Elven",
		image: "img_assetpack_elven.jpg",
		pack: "pack-elves",
		text: `<p><strong>25 Kickstarter exclusive</strong> assets for regional landmarks, city buildings and world maps.</p>`,
		download: null,
	},
	orcish: {
		name: "Orcish",
		image: "img_assetpack_orcish.jpg",
		pack: "pack-orcs",
		text: `<p><strong>25 Kickstarter exclusive</strong> assets for regional landmarks, city buildings and world maps.</p>`,
		download: "https://deios-api.prd.dungeonfog.com/download?file=Caeora_Orc_Pack.zip",
	},
	lovecraftian: {
		name: "Lovecraftian",
		image: "img_assetpack_lovecraft.jpg",
		pack: "pack-lovecraft",
		text: `<p><strong>25 Kickstarter exclusive</strong> assets for regional landmarks, city buildings and world maps.</p>`,
		download: null,
	},
	titaniccreatures: {
		name: "Titanic Creatures",
		image: "img_assetpack_titaniccreatures.jpg",
		pack: "pack-giant-creatures",
		text: `<p><strong>25 Kickstarter exclusive</strong> assets for regional landmarks, city buildings and world maps.</p>
			   <p class="box unlocked" style="width: 95%; height: auto; min-height: auto; background-color: #2c567d;"><strong>Unlocked during Alpha</strong></p>`,
		download: null,
	},
	evillairs: {
		name: "Evil Lairs",
		image: "img_assetpack_evillairs.jpg",
		pack: "pack-evil-lairs",
		text: `<p><strong>25 Kickstarter exclusive</strong> assets for regional landmarks, city buildings and world maps.</p>`,
		download: null,
	},
	caracasses: {
		name: "Carcasses",
		image: "img_assetpack_carcasses.jpg",
		pack: "social-goals",
		text: `<p><strong>25 Kickstarter exclusive</strong> assets for regional landmarks, city buildings and world maps.</p>`,
		download: null,
	},
	artefacts: {
		name: "Artefacts",
		image: "img_assetpack_artefacts.jpg",
		pack: "social-goals",
		text: `<p><strong>25 Kickstarter exclusive</strong> assets for regional landmarks, city buildings and world maps.</p>`,
		download: null,
	},
	wonders: {
		name: "Wonders",
		image: "img_assetpack_wonders.jpg",
		pack: "social-goals",
		text: `<p><strong>25 Kickstarter exclusive</strong> assets for regional landmarks, city buildings and world maps.</p>`,
		download: null,
	}
};

</script>
